export default __webpack_public_path__ + "static/srtiplogo-939351fe36d024b5ad1afd12d9a7ea58.png";